// extracted by mini-css-extract-plugin
export var arrows = "_97-6";
export var decrementer = "_97-a";
export var disabled = "_97-4";
export var error = "_97-1";
export var hiddenText = "_97-b";
export var incrementer = "_97-9";
export var input = "_97-8";
export var inputWrapper = "_97-0";
export var leadingIcon = "_97-c";
export var readonly = "_97-3";
export var regular = "_97-7";
export var small = "_97-5";
export var warning = "_97-2";